import type { SVGProps } from 'react';
const SvgIconCommentFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#3E704B"
      d="M24 12.53c0 4.713-4.7 8.532-10.5 8.532-1.521 0-2.965-.263-4.269-.734-.488.356-1.284.844-2.227 1.255-.984.426-2.17.791-3.347.791a.657.657 0 0 1-.467-1.12l.012-.012a5 5 0 0 0 .254-.291c.169-.205.394-.509.624-.886.41-.68.8-1.575.878-2.58C3.728 16.091 3 14.381 3 12.531 3 7.818 7.7 4 13.5 4S24 7.818 24 12.53"
    />
  </svg>
);
export default SvgIconCommentFilled;
